export const emojiFilter = (emoji: string): boolean => {
  const emojisFilteredOut: string[] = [
    '1F92C', // 🤬
    '1F608', // 😈
    '1F47F', // 👿
    '1F480', // 💀
    '2620-FE0F', // ☠️
    '1F4A9', // 💩
    '1F921', // 🤡
    '1F479', // 👹
    '1F47A', // 👺
    '1F485', // 💅
    '1F445', // 👅
    '1F444', // 👄
    '1F935-200D-2642-FE0F', // 🤵‍♂️
    '1F935-200D-2640-FE0F', // 🤵‍♀️
    '1F470', // 👰
    '1F470-200D-2642-FE0F', // 👰‍♂️
    '1F470-200D-2640-FE0F', // 👰‍♀️
    '1F930', // 🤰
    '1F931', // 🤱
    '1F469-200D-1F37C', // 👩‍🍼
    '1F468-200D-1F37C', // 👨‍🍼
    '1F9D1-200D-1F37C', // 🧑‍🍼
    '1F9DB-200D-2642-FE0F', // 🧛‍♂️
    '1F9DB-200D-2640-FE0F', // 🧛‍♀️
    '1F9DC-200D-2642-FE0F', // 🧜‍♂️
    '1F9DC-200D-2640-FE0F', // 🧜‍♀️
    '1F9DD-200D-2642-FE0F', // 🧝‍♂️
    '1F9DD-200D-2640-FE0F', // 🧝‍♀️
    '1F9DE-200D-2642-FE0F', // 🧞‍♂️
    '1F9DE-200D-2640-FE0F', // 🧞‍♀️
    '1F9DF-200D-2642-FE0F', // 🧟‍♂️
    '1F9DF-200D-2640-FE0F', // 🧟‍♀️
    '1F468-200D-1F9AF', // 👨‍🦯
    '1F469-200D-1F9AF', // 👩‍🦯
    '1F9D1-200D-1F9BC', // 🧑‍🦼
    '1F468-200D-1F9BC', // 👨‍🦼
    '1F469-200D-1F9BC', // 👩‍🦼
    '1F9D1-200D-1F9BD', // 🧑‍🦽
    '1F468-200D-1F9BD', // 👨‍🦽
    '1F469-200D-1F9BD', // 👩‍🦽
    '1F46F-200D-2642-FE0F', // 👯‍♂️
    '1F46F-200D-2640-FE0F', // 👯‍♀️
    '1F9D6-200D-2642-FE0F', // 🧖‍♂️
    '1F9D6-200D-2640-FE0F', // 🧖‍♀️
    '1F6C0', // 🛀
    '1F6CC', // 🛌
    '1F9D1-200D-1F91D-200D-1F9D1', // 🧑‍🤝‍🧑
    '1F46D', // 👭
    '1F46B', // 👫
    '1F46C', // 👬
    '1F469-200D-2764-FE0F-200D-1F48B-200D-1F468', // 👩‍❤️‍💋‍👨
    '1F468-200D-2764-FE0F-200D-1F48B-200D-1F468', // 👨‍❤️‍💋‍👨
    '1F469-200D-2764-FE0F-200D-1F48B-200D-1F469', // 👩‍❤️‍💋‍👩
    '1F469-200D-2764-FE0F-200D-1F468', // 👩‍❤️‍👨
    '1F468-200D-2764-FE0F-200D-1F468', // 👨‍❤️‍👨
    '1F469-200D-2764-FE0F-200D-1F469', // 👩‍❤️‍👩
    '1F468-200D-1F469-200D-1F466', // 👨‍👩‍👦
    '1F468-200D-1F469-200D-1F467', // 👨‍👩‍👧
    '1F468-200D-1F469-200D-1F467-200D-1F466', // 👨‍👩‍👧‍👦
    '1F468-200D-1F469-200D-1F466-200D-1F466', // 👨‍👩‍👦‍👦
    '1F468-200D-1F469-200D-1F467-200D-1F467', // 👨‍👩‍👧‍👧
    '1F468-200D-1F468-200D-1F466', // 👨‍👨‍👦
    '1F468-200D-1F468-200D-1F467', // 👨‍👨‍👧
    '1F468-200D-1F468-200D-1F467-200D-1F466', // 👨‍👨‍👧‍👦
    '1F468-200D-1F468-200D-1F466-200D-1F466', // 👨‍👨‍👦‍👦
    '1F468-200D-1F468-200D-1F467-200D-1F467', // 👨‍👨‍👧‍👧
    '1F469-200D-1F469-200D-1F466', // 👩‍👩‍👦
    '1F469-200D-1F469-200D-1F467', // 👩‍👩‍👧
    '1F469-200D-1F469-200D-1F467-200D-1F466', // 👩‍👩‍👧‍👦
    '1F469-200D-1F469-200D-1F466-200D-1F466', // 👩‍👩‍👦‍👦
    '1F469-200D-1F469-200D-1F467-200D-1F467', // 👩‍👩‍👧‍👧
    '1F468-200D-1F466', // 👨‍👦
    '1F468-200D-1F466-200D-1F466', // 👨‍👦‍👦
    '1F468-200D-1F467', // 👨‍👧
    '1F468-200D-1F467-200D-1F466', // 👨‍👧‍👦
    '1F468-200D-1F467-200D-1F467', // 👨‍👧‍👧
    '1F469-200D-1F466', // 👩‍👦
    '1F469-200D-1F466-200D-1F466', // 👩‍👦‍👦
    '1F469-200D-1F467', // 👩‍👧
    '1F469-200D-1F467-200D-1F466', // 👩‍👧‍👦
    '1F469-200D-1F467-200D-1F467', // 👩‍👧‍👧
    '1F48B', // 💋
    '1F48C', // 💌
    '1F498', // 💘
    '1F49D', // 💝
    '1F496', // 💖
    '1F497', // 💗
    '1F493', // 💓
    '1F49E', // 💞
    '1F495', // 💕
    '1F49F', // 💟
    '2763-FE0F', // ❣️
    '1F494', // 💔
    '1F38B', // 🎋
    '1F38D', // 🎍
    '1F38E', // 🎎
    '1F38F', // 🎏
    '1F390', // 🎐
    '1F391', // 🎑
    '1F9E7', // 🧧
    '1F380', // 🎀
    '1F397-FE0F', // 🎗️
    '1F39F-FE0F', // 🎟️
    '1F3AB', // 🎫
    '1F383', // 🎃
    '1F384', // 🎄
    '1F386', // 🎆
    '1F9E8', // 🧨
    '2728', // ✨
    '26BD', // ⚽
    '26BE', // ⚾
    '1F94E', // 🥎
    '1F3C0', // 🏀
    '1F3D0', // 🏐
    '1F3C8', // 🏈
    '1F3C9', // 🏉
    '1F3BE', // 🎾
    '1F94F', // 🥏
    '1F3B3', // 🎳
    '1F3CF', // 🏏
    '1F3D1', // 🏑
    '1F3D2', // 🏒
    '1F94D', // 🥍
    '1F3D3', // 🏓
    '1F3F8', // 🏸
    '1F94A', // 🥊
    '1F94B', // 🥋
    '1F945', // 🥅
    '26F3', // ⛳
    '26F8-FE0F', // ⛸️
    '1F3A3', // 🎣
    '1F93F', // 🤿
    '1F3BD', // 🎽
    '1F3BF', // 🎿
    '1F6F7', // 🛷
    '1F94C', // 🥌
    '1FA80', // 🪀
    '1FA81', // 🪁
    '1F3B1', // 🎱
    '1F52E', // 🔮
    '1F9FF', // 🧿
    '1F3AE', // 🎮
    '1F579-FE0F', // 🕹️
    '1F3B0', // 🎰
    '1F3B2', // 🎲
    '1F9E9', // 🧩
    '1F9F8', // 🧸
    '2660-FE0F', // ♠️
    '2665-FE0F', // ♥️
    '2666-FE0F', // ♦️
    '2663-FE0F', // ♣️
    '265F-FE0F', // ♟️
    '1F0CF', // 🃏
    '1F004', // 🀄
    '1F3B4', // 🎴
    '1F3AD', // 🎭
    '1F5BC-FE0F', // 🖼️
    '1F3A8', // 🎨
    '1F9F5', // 🧵
    '1F9F6', // 🧶
    '1F9D1-200D-1F9B0', // 🧑‍🦰
    '1F9D1-200D-1F9B3', // 🧑‍🦳
    '1F9D1-200D-1F9B2', // 🧑‍🦲
    '1F9D1-200D-1F9B1', // 🧑‍🦱
    '1F9D1-200D-1F680', // 🧑‍🚀
    '1F9D1-200D-1F692', // 🧑‍🚒
    '1F9D1-200D-1F384', // 🧑‍🎄
    '1F9D1-200D-1F9AF', // 🧑‍🦯
    '1F9D1-200D-1F3ED', // 🧑‍🏭
    '1F9D1-200D-1F3A4', // 🧑‍🎤
    '1F9D1-200D-1F52C', // 🧑‍🔬
    '1F9D1-200D-1F373', // 🧑‍🍳
    '1F9D1-200D-2708-FE0F', // 🧑‍✈️
    '1F9D1-200D-1F33E', // 🧑‍🌾
    '1F9D1-200D-2696-FE0F', // 🧑‍⚖️
    '1F9D1-200D-1F3EB', // 🧑‍🏫
    '1F9D1-200D-1F393', // 🧑‍🎓
    '1F9D1-200D-1F527', // 🧑‍🔧
    '1F9D1-200D-1F4BC', // 🧑‍💼
    '1F9D1-200D-1F3A8', // 🧑‍🎨
    '1F9D1-200D-1F4BB', // 🧑‍💻
    '1F9D1-200D-2695-FE0F', // 🧑‍⚕️
    '1F972', // not supported
    '1F977', // not supported
    '1F978', // not supported
    '1F90C', // not supported
    '1FAC1', // not supported
    '1FAC2', // not supported
    '1FA84', // not supported
    '1FA85', // not supported
    '1FA86', // not supported
    '1FAA1', // not supported
    '1FAA2', // not supported
    '1FAC0', // not supported
  ];
  return !emojisFilteredOut.includes(emoji);
};
